import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import VueSocketIO from 'vue-socket.io'
import * as io from 'socket.io-client'
import '@/assets/fonts/css/icons.css'
import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'
import '@/assets/css/style.css'
import '@/assets/css/modal.css'
import '@/assets/css/language.css'
import '@/assets/js/custom.js'
import VueResource from 'vue-resource'
import 'vue-loading-overlay/dist/vue-loading.css'
import store from './store'
import i18n from '@/utils/i18n'
import { SOCKET_URL, SOCKET_LOCAL_URL } from './utils/constant'
import VueCookie from 'vue-cookie'

window.__native_money91 = {}
window._AI = {}
Vue.use(VueResource)
Vue.use(VueCookie)
window.SocketDebug = false

if (process.env.NODE_ENV === 'development') {
  window.SocketDebug = true
} else {
  window.SocketDebug
  // console.log = function(){}
  document.addEventListener(
    'contextmenu',
    function(e) {
      e.preventDefault()
    },
    false
  )
}

Vue.use(Toast, {
  defaultType: 'center',
  duration: 2000,
  wordWrap: true,
  width: '400px'
})

Vue.config.productionTip = false

Vue.use(
  new VueSocketIO({
    debug: window.SocketDebug,
    connection: io(SOCKET_URL, {
      query: {
        token:
          VueCookie.get('X-Auth-Token') == null
            ? ''
            : VueCookie.get('X-Auth-Token')
      },
      reconnectionDelay: 1000
    })
  })
)
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
